import { SystemRole } from "./../types/authentication";
import { StoreState } from "./storeState";
import { AppContext } from "../types/appContext";

export const initialState: StoreState = {
  virtualMeetingConnection: "",
  dnaRepresentatives: [],
  appContext: new AppContext(),
  authentication: {
    loginUser: {
      id: "-1",
      name: "",
      email: "",
      role: SystemRole.BranchStaff,
      username: "",
      permissions: []
    },
    isAuthenticated: false
  },
  branchAdmins: [],
  systemAdmins: [],
  allAdminCategories: [],
  branches: [],
  branchHours: [],
  adminAppSettings: {
    dnaUsername: "",
    exchangeUsername: "",
    notificationSettings: {
      blackoutStartTime: "00:00",
      blackoutEndTime: "00:00"
    },
    selectedRegions: [],
    allRegions: [],
    zoomMeetingApiKey: "",
    zoomMeetingApiSecret: ""
  },
  appSettings: {
    isInternal: false,
    googleMapsApiKey: "",
    adminHomepageUrl: "",
    skypeAppId: "",
    twilioConfigured: false,
    logoUrl: "./img/logo.jpg",
    palette: {
      primary: {
        main: "",
        contrastText: ""
      },
      secondary: {
        main: "",
        contrastText: ""
      }
    },
    organizationSettings: {
      orgLongName: "",
      orgShortName: "",
      virtualMeetingType: "phone",
      phoneMeetingLocation: "",
      zoomMeetingLocation: "",
      userInitiatedFeedbackEnabled: false,
      feedbackStartExpirationDays: 30,
      feedbackDaysBetweenSolicit: 0,
      usePreferredAgentRouting: false,
      skipAgentSelection: false,
      textIsDisabled: false,
      disableCustomLocations: false,
      appointmentHoldTimeInSeconds: 300,
      appointmentLeadTimeDays: 1,
      appointmentLeadTimeConstraints: {
        minValue: 1,
        maxValue: 365,
        customConstraint: ""
      },
      appointmentWindowDays: 7,
      appointmentWindowConstraints: {
        minValue: 7,
        maxValue: 62,
        customConstraint: ""
      },
      sameDayBufferMinutes: 0,
      sameDayBufferConstraints: {
        minValue: 0,
        maxValue: 360,
        customConstraint: ""
      },
      meetingDurationConstraints: {
        minValue: 15,
        maxValue: 240,
        customConstraint: ""
      },
      wrapUpDurationConstraints: {
        minValue: 0,
        maxValue: 60,
        customConstraint: ""
      }
    },
    skypeSettings: {
      domain: "",
      isSkypeOnPrem: false,
      enableSkype365Feature: false
    }
  },
  reminders: [],
  visitCategories: [],
  defaultCustomerPrefs: {
    customerId: 0,
    remindersEnabled: false,
    calendarInviteEnabled: false,
    feedbackEnabled: false,
    communicationPreference: "EMAIL",
    isMobilePhone: true
  },
  errorMessage: { visible: false },
  serviceRepresentatives: [],
  systemTimeZones: [],
  videos: {
    path: "",
    videoTitles: []
  },
  appointmentsListReport: {
    report: []
  },
  volumeReport: {
    report: []
  },
  serviceLocationReport: {
    report: []
  },
  marketingLinks: [],
  surveyDto: {
    id: -1,
    userInitiatedFeedbackEnabled: false,
    systemInitiatedFeedbackEnabled: false,
    feedbackDaysBetweenSolicit: 0,
    threshold: 0.0,
    enableThresholdNotification: false,
    sampleRate: -1,
    solicitMessage: "",
    questions: []
  },
  resourceByServiceReport: {
    report: []
  },
  callDownListReport: {
    report: []
  },
  serviceLevelsReport: {
    report: []
  },
  surveyFeedbackDetailsReport: {
    report: []
  },
  surveyFeedbackSummaryReport: {
    report: []
  },
  marketingLinkSummaryReport: {
    report: []
  },
  failedAppointmentAttemptsReport: {
    report: []
  },
  reportingSyncUpdatedTime: ""
};

export default initialState;
